<div [formGroup]="messageForm" class="discussion-view-wrapper h-100 flex flex-col">
  @if (!hideHeader()) {
    <div class="py-3 flex border-b border-solid border-navy-300">
      <app-messaging-bubble
        [isFilled]="!selectedGroup?.is_read"
        [type]="getBubbleType(selectedGroup)"
      ></app-messaging-bubble>
      <div class="ml-6 text-navy-700 font-semibold">{{ (selectedGroup$ | async)?.name }}</div>
    </div>
    <div
      (click)="toggleShowParticipants()"
      #userTableTrigger="cdkOverlayOrigin"
      cdkOverlayOrigin
      class="form dropdown-form hide-underline flex items-center justify-between py-2 cursor-pointer border-b border-solid border-navy-300 overflow-visible"
    >
      <app-overlay-general
        #optionsListGeneralComponent
        [show]="isDropDownOpen"
        (showChange)="toggleShowParticipants($event)"
        [trigger]="userTableTrigger"
        [withAnimation]="false"
      >
        <app-messaging-users-table
          [listItems]="itemOptions"
          [usersRelated]="usersData.usersRelated"
          [discussionMembers]="usersData.discussionMembers"
          (selectedOption)="onMemberOptionSelected($event)"
        ></app-messaging-users-table>
      </app-overlay-general>
      <div class="flex-1 flex items-center">
        <span
          (click)="$event.stopPropagation(); toggleShowRelatedUsers(true)"
          [ngClass]="{ 'icon-new-message-plus-chat-unfilled': !showRelatedUsers, 'icon-at-sign': showRelatedUsers }"
          class="icon"
        ></span>
        <span class="flex flex-wrap gap-x-2 ml-4">
          @for (user of usersData.discussionMembers; track user) {
            <span
              [ngClass]="{ 'font-semibold': user?.is_admin, 'font-normal': !user?.is_admin }"
              class="pr-5 text-navy-700 font-sm text-nowrap"
            >
              {{ user.name }}
            </span>
          }
          @if (showRelatedUsers && isDropDownOpen) {
            <input
              #input
              placeholder="Type a name..."
              class="clean-input"
              autocomplete="off"
              formControlName="participants"
              (input)="onMemberInputChange($event)"
            />
          }
        </span>
      </div>
      <div class="flex items-center cursor-pointer pl-2">
        <app-arrow-button-box
          [direction]="isDropDownOpen ? 'up' : 'down'"
          [isFilled]="isDropDownOpen"
        ></app-arrow-button-box>
      </div>
    </div>
  }
  <!--  class can be found in global styles-->
  @if (isPaginationLoading$ | async) {
    <mat-progress-bar class="custom-loading-progress-bar" mode="indeterminate"></mat-progress-bar>
  }
  <div class="flex-1 min-h-0">
    @if (isLoading$ | async) {
      <div class="h-100 flex justify-center items-center">
        <span class="icon-refresh animate-spin text-size_title_xl text-navy-600"></span>
      </div>
    }
    @if (!(isLoading$ | async)) {
      <ng-scrollbar #scrollbar class="std-scrollbar" orientation="vertical" appearance="native">
        <div [ngClass]="{ 'mr-3': scrollbar.isVerticallyScrollable() }">
          @for (message of allMessages; track trackByFn($index, message)) {
            @if (!(message.body | isMessageEmpty) || message.attachments?.length) {
              <div id="{{ 'message-' + message.id }}" [ngClass]="{ 'py-3 ': !message.is_announcement }">
                @if (!message?.is_announcement) {
                  <app-message-item [message]="message"></app-message-item>
                }
                @if (message?.is_announcement) {
                  <app-message-item-announcement [message]="message"></app-message-item-announcement>
                }
              </div>
            }
          }
        </div>
      </ng-scrollbar>
    }
  </div>

  <div class="border-separator"></div>
  @if (!draftLoaded) {
    <div class="py-2 flex w-full items-center justify-center h-[244px]">
      <div class="notify-msg animate-pulsating-border">
        <div class="icon-logo-box-hex"></div>
      </div>
    </div>
  } @else {
    <app-rich-text-editor
      [editorValue]="editorValue"
      (editorValueChange)="onEditorValueChange($event)"
      [userMentions]="usersData.discussionMembers"
      [projectMentions]="projectMentions$ | async"
      [allowFileUpload]="true"
      [filesToUpload]="filesToUpload$ | async"
      (filesToUploadChange)="registerFileUpload($event)"
      (removedFileToUpload)="removeFile($event)"
      enterKeyPressBehaviour="custom"
      (enterKeyPress)="footerService.emitSave()"
      class="h-52"
    >
      <div class="right-button-container">
        <app-simple-button (click)="footerService.emitSave()" buttonStyle="color_accent_filled">Send</app-simple-button>
      </div>
    </app-rich-text-editor>
  }
</div>
